import React from 'react';
import { Link } from 'react-router-dom';
import { FlaskConical, X } from 'lucide-react';

const BetaBanner = () => {
  const [dismissed, setDismissed] = React.useState(() => {
    return sessionStorage.getItem('mosaic_beta_dismissed') === 'true';
  });

  if (dismissed) return null;

  const handleDismiss = () => {
    sessionStorage.setItem('mosaic_beta_dismissed', 'true');
    setDismissed(true);
  };

  return (
    <div
      className="bg-gradient-to-r from-emerald-600 to-teal-600 text-white px-4 py-2 text-center text-sm font-medium no-print relative"
      data-testid="beta-banner"
    >
      <div className="flex items-center justify-center gap-2 flex-wrap">
        <span className="inline-flex items-center gap-1.5 px-2 py-0.5 bg-white/20 text-xs font-bold tracking-wider rounded-sm">
          <FlaskConical size={12} />
          WAITLIST
        </span>
        <span>
          Join the MOSAIC Pilot Waitlist — be among the first NYC schools invited when beta access opens.
        </span>
        <Link
          to="/join-beta"
          className="underline font-bold hover:text-yellow-300 transition-colors"
          data-testid="beta-banner-join-link"
        >
          Join the Waitlist
        </Link>
      </div>
      <button
        onClick={handleDismiss}
        className="absolute right-3 top-1/2 -translate-y-1/2 text-white/70 hover:text-white transition-colors"
        aria-label="Dismiss beta banner"
        data-testid="beta-banner-dismiss"
      >
        <X size={16} />
      </button>
    </div>
  );
};

export default BetaBanner;
